module.exports = __webpack_public_path__ + "img/french_75.426c847b.jpg";